<template>
  <div>
    <div class="pane-group">
      <!-- <div class="pane-sm" >
        <h5>Placeholder</h5>
        
        
      </div> -->

      <div class="pane">
        <h1>Litres To Packs Comparison</h1>

        

        <button :disabled="test" class="btn btn-default" @click="forceRefresh">Force Refresh (takes up to 30 seconds)</button> <p>{{refreshedState}}</p>

        

        <!-- <apexchart width="550" type="bar" :options="chartOptions" :series="series"></apexchart> -->
        <button class="btn btn-default" @click="toggleYTD">Toggle YTD</button> 
        <apexchart width="800" :options="combinedChartOptions" :series="combinedSeries"></apexchart>

        <button class="btn btn-default" @click="toggleYTD">Toggle YTD</button> 
        <apexchart width="800" :options="rcChartOptions" :series="rcSeries"></apexchart>
        
        <button class="btn btn-default" @click="toggleYTD">Toggle YTD</button> 
        <apexchart width="800" :options="rmChartOptions" :series="rmSeries"></apexchart>

        <div id="chart"></div>
        <!-- <div>
          <button @click="updateChart">Update!</button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable indent, block-spacing */
/* global axios, i_axios, moment */
// import ApexCharts from 'apexcharts'
export default {
  name: 'SummaryReport01',
  async mounted(){
    this.$loadApex();
  },
  async created () {
    await this.loadData(false)
    
    
  },
  data () { return { 
    refreshedState: '',
    isYTD: false,
    test: false,
    chartOptions:{
      chart: {
        height: 350,
        // type: 'line',
      },
      // stroke: {
      //   width: [0, 4]
      // },
      title: {text: 'Litres to Packs'},
      labels: [],
      xaxis: {/*type: 'datetime'*/},
      tooltip:{
        y:[{formatter: v => `${numeral(v).format('0,0')} Litres`},
          {formatter: v => `${numeral(v).format('0,0')} Packs`},
          {formatter: v => `${numeral(v).format('0,0')} Litres`},
          {formatter: v => `${numeral(v).format('0,0')} Packs`}]
      },
      yaxis: [{
        title: {text: 'Litres',},
        labels: {formatter: v => `${numeral(v).format('0.0a')} L`},
        max: 9000000,
        min: 0
      }, {
        opposite: true,
        title: {text: 'Cig. Packs'},
        labels: {formatter: v => `${numeral(v).format('0a')} Packs`},
        max: 180000,
        min: 0
      },{
        show: false,
        title: {text: 'Litres',},
        labels: {formatter: v => `${numeral(v).format('0.0a')} L`},
        max: 9000000,
        min: 0
      }, {
        show: false,
        opposite: true,
        title: {text: 'Cig. Packs'},
        labels: {formatter: v => `${numeral(v).format('0a')} Packs`},
        max: 180000,
        min: 0
      }],
      },

      rmChartOptions : {},
      rcChartOptions : {},
      combinedChartOptions : {},

      rmSeries: [{
        name: 'Litres',
        type: 'column',
        data: []
      }, {
        name: 'Cig. Packs',
        type: 'line',
        data: []
      }],
      rcSeries: [{
        name: 'Litres',
        type: 'column',
        data: []
      }, {
        name: 'Cig. Packs',
        type: 'line',
        data: []
      }],

      combinedSeries: [{
        name: 'RC Litres',
        type: 'column',
        data: []
      }, {
        name: 'RC Cig. Packs',
        type: 'line',
        data: []
      }, {
        name: 'RM Litres',
        type: 'column',
        data: []
      }, {
        name: 'RM Cig. Packs',
        type: 'line',
        data: []
      }],

      selectedLocation: 'RCGB',
      list: [],
      listFormatters: {},
      listTitles: {
        'ts' : 'Timestamp', 
      },
      // from: undefined,
      // to: undefined,
      from: '2018-08-08 00:04:31',
      to: '2018-08-08 07:56:54',
    } 
  },
  methods: {

    loadData: async function (refresh, ytd = false) {
      let datePeriodText = ytd ? 'YTD' : 'Cal. Year';
      let rc = i_axios.post('/Reports/SummaryReports/SummaryReport01', {location:'RCGB', refresh, ytd}).then((r)=>{
        
        this.rcChartOptions = {...this.chartOptions, ...{title: {text: `RC Litres to Packs - ${datePeriodText} - During RM Hours`}}}
        let data = r.data.filter(r=>r.year >= 2014)
        this.chartOptions = {...this.chartOptions, ...{labels: data.map(r=>r.year) }}
        this.rcSeries[0].data = data.map(r=>r.litres)
        this.rcSeries[1].data = data.map(r=>r.packs)
        this.combinedSeries[0].data = data.map(r=>r.litres)
        this.combinedSeries[1].data = data.map(r=>r.packs)
      })
      let rm = i_axios.post('/Reports/SummaryReports/SummaryReport01', {location:'RMGB', refresh, ytd}).then((r)=>{

        this.rmChartOptions = {...this.chartOptions, ...{title: {text: `RM Litres to Packs - ${datePeriodText} - During RM Hours`}}}
        let data = r.data.filter(r=>r.year >= 2014)
        this.rmSeries[0].data = data.map(r=>r.litres)
        this.rmSeries[1].data = data.map(r=>r.packs)
        this.combinedSeries[2].data = data.map(r=>r.litres)
        this.combinedSeries[3].data = data.map(r=>r.packs)
      })

      return Promise.all([rc, rm]).then(()=>{
        this.combinedChartOptions = {...this.chartOptions, ...{title: {text: `RC/RM Litres to Packs - ${datePeriodText} - During RM Hours`}}}
      })

    },
    forceRefresh: async function(){
      this.refreshedState = 'Refreshing...'
      this.test = true;
      await this.loadData(true, this.isYTD);
      this.refreshedState = 'Refreshed'
      this.test = false;
    },
    toggleYTD: async function(){
      this.isYTD = !this.isYTD;
      if (this.isYTD){
        this.chartOptions = { yaxis: {max: undefined} }
      } else {
        this.chartOptions = { yaxis: {max: 9000000} }
      }
      await this.loadData(false, this.isYTD);
      
    },
    refreshIsDisabled: function(){
      console.log('refreshIsDisabled', this.refreshedState === 'Refreshing...')
      return this.refreshedState === 'Refreshing...';
    }
  }, 
}



</script>

<style>
  
</style>
